import { render } from "./airTemperature.vue?vue&type=template&id=ebbdea18&ts=true"
import script from "./airTemperature.vue?vue&type=script&lang=ts"
export * from "./airTemperature.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__